import React from 'react';
import styles from './completeModal.module.scss';
import Modal from '@src/components/modal/Modal';
import Button from '@src/components/button/Button';
import Spinner from '@src/components/spinner/Spinner';

type Props = {
  open: boolean;
  loading?: boolean;
  onClose: () => void;
  onComplete: () => void;
};

function ForceCompleteModal(props: Props) {
  const { open, loading, onClose, onComplete } = props;
  return (
    <Modal global={false} open={open} onClose={onClose} className={styles.wrapper} closeButton={false} >
      <div className={styles.container}>
        <div className={styles.newContent}>
          <div className={styles.newTitle}><span className='bold'>Mark This Lesson Complete?</span></div>
          <div className={styles.btnActions}>
            <Button disabled={loading} size={'small'} onClick={onComplete} leftIcon={loading ? <Spinner width={35} height={35} /> : undefined} className={styles.yesButton} label={'Yes'}/>
            <Button disabled={loading} size={'small'} onClick={onClose} leftIcon={loading ? <Spinner width={35} height={35} /> : undefined} outline={true} color='orange' className={styles.noButton} label={'No, I’m still looking'}/>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default ForceCompleteModal;
